import React from 'react';
import { CircularProgress, makeStyles, Box } from '@material-ui/core';

const useStyle = makeStyles(theme => ({
  loader: {
    width: '100%',
    display: 'flex',
    height: '25rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const PageLoader = ({ show = false }) => {
  const classes = useStyle();

  return (
    <Box className={classes.loader}>
      <CircularProgress />
    </Box>
  );
};

export default PageLoader;
